import { BaseAtlas } from './BaseAtlas';

/**
 * Auto-generated class for atlas "spritesheets/cards/backs/39_card_back_palace/39_card_back_palace"
 * Contains 1 texture(s)
 */
export class CardsBacks39CardBackPalaceAtlas extends BaseAtlas {
    /**
     * Atlas path
     */
    protected static readonly ATLAS_PATH = 'spritesheets/cards/backs/39_card_back_palace/39_card_back_palace';

    /**
     * List of all available textures in atlas
     */
    protected static readonly TEXTURES = [
        '39_palace.png'
    ] as const;
}
